import CollectionApi from 'client/api/v2/CollectionApi';
import IpListType from 'client/Security/IpListType';

function cons(item) {
  return new IpListType(item);
}

class IpListsApi extends CollectionApi {
  constructor() {
    super('/api/v2/iplists', {
      skip: 0,
      limit: 100,
      sort: '',
      // Sorting and searching not available in /iplists API yet -- MC 9/21/20
      // sort: 'name', // Prepend with a '-' to reverse default sort direction
      // search: {
      //   fields: [
      //     'name',
      //   ],
      //   searchTerm: '',
      // },
    });
  }

  async fetch(...args) {
    const res = await super.fetch(...args);

    if (Array.isArray(res.results)) {
      res.results = res.results.map(cons);
    }

    return res;
  }
}

export default new IpListsApi();
